import React, { useEffect, useState, useCallback } from "react";
import styles from "./DataTable.module.css";
import Pagination from "./Pagination";
import { salesListing } from "../../../Bookclosure/Services/ApiHandler";

const DataTable = ({ SaleID = "6916f64db2634815b26021fa", filters = [] }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

  const formatHeading = (text) =>
    text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();


  useEffect(() => {
  setActiveFilters(filters);
  setCurrentPage(1);
  }, [filters]);

  
  const loadData = useCallback(async () => {
    try {
      const response = await salesListing(SaleID, {
        page: currentPage,
        pageSize: rowsPerPage,
        filters: activeFilters, 
      });

      const res = response.data;

      setColumns(res.saleListingHeaders);
      setData(res.saleListing);
      setTotalPages(res.totalPages);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [SaleID, currentPage, rowsPerPage, activeFilters]);

    useEffect(() => {
      loadData();
    }, [loadData]);



  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{formatHeading(col)}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => (
              <tr key={row.id || i}>
                {columns.map((col) => (
                  <td key={col}>{row[col] ?? "-"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default DataTable;
